<template>
  <div :class="classString" v-show="drawChart">
    <GChart :settings="{ packages: ['corechart', 'controls'] }" style="display: none" type="BarChart" @ready="onChartReady" />
    <div :id="titleAndChartContainer" class="d-flex col">    
      <div id="nps-title-and-chart" class="title-and-chart">
        <div class="title-and-chart-left">
          <div class="chart-title-container">
            <h4 class="text-primary">Net Promoter Score</h4>
          </div>      
          <chart-buttons
            :display="true"
            :tooltip-configuration="snapChartTooltipConfig"
            :snap-container-id="titleAndChartContainer"
            :container-id="containerId"
            :report-page-type-name="'Chart - Net Promoter Score'"
            :snap-label="'Snap'"
            :include-other-snap-buttons="false"
            :insight-modal-id="chartInsightModalId"
            :include-text-direction="false"
          ></chart-buttons>
        </div>
      </div>
      <div :id="containerId" class="chart"></div>
    </div>
    <div :id="dataContainerId" class="col-6">
      <chart-data-table
        ref="npsDataTable"
        :chart-data="npsData"
        :display-direction="'vertical'"
        :data-container-id="dataContainerId"
        :container-id="containerId"
        :column-defs="this.columnDefsNps"
        :table-class="'table display row-border table-hover'"
        table-title='<h4 class="text-primary">Net Promoter Score</h4>'
        :table-width="'auto'"
        :report-page-type-name="tableReportPageTypeName"
        :insight-modal-id="tableInsightModalId"
      ></chart-data-table>
    </div>
    <insights
      ref="insightsNPSTable"
      :modal-name="tableInsightModalId"
      :report-page-type-name="tableReportPageTypeName"
      :entry-page-content="this.$parent.pageContentForReport"
      @saveReportPage="updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="saveClientChart"
    />
    <insights
      ref="insightsNPSChart"
      :modal-name="chartInsightModalId"
      :report-page-type-name="chartReportPageTypeName"
      :entry-page-content="this.$parent.pageContentForReport"
      @saveReportPage="updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";

import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ChartDataTable from "../../components/chart/ChartDataTable.vue";
import ChartButtons from "../../components/chart/ChartButtons.vue";

import TableService from "../../services/table.service";
import ChartService from "../../services/chart.service";
import ReportService from "../../services/report.service";
import Insights from "../../modals/Insights.vue";

export default {
  name: "NetPromoterScore",
  mixins: [ContentMixins, ChartCompanyMixins],
  components: { ChartDataTable, Insights, ChartButtons},
  data() {
    return {
      tableInsightModalId: "",
      chartInsightModalId: "",
      tableReportPageTypeName: "Table - Net Promoter Score",
      chartReportPageTypeName: "Chart - Net Promoter Score",
      npsChart: {},
    };
  },
  props: {
    drawChart: {
      type: Boolean,
      default: false
    },
    containerClass: {
      type: String,
      default: "col"
    },
    npsData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    npsChartData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    containerId: {
      type: String,
      default: "nps_chart"
    },
    dataContainerId: {
      type: String,
      default: "nps_data_container"
    }
  },
  computed: {
    titleAndChartContainer: function(){
      return this.containerId + "-title-and-chart";
    },
    classString: function() {
      return "nps-container " + this.containerClass;
    }
  },
  mounted() {},
  created() {
    this.columnDefsNps = TableService.getNpsTableColumnAttributes();
    this.chartInsightModalId = "nps-chart-" + this.dataContainerId;
    this.tableInsightModalId = "nps-table-" + this.dataContainerId;
    this.chart = ChartService.getChartAttributes("Net Promoter Score");
  },
  methods: {
    onChartReady(chart, google) {
      this.chartsLib = google;      
      this.npsChart = new google.visualization.ChartWrapper({
        chartType: "BarChart",
        containerId: this.containerId
      });
    },    
    saveClientChart(value, message) {
      this.$parent.saveClientChart(value, message);
    },
    updateReportPages(value) {
      this.$parent.updateReportPages(value);
    },
    saveAllReportPages() {
      this.$parent.saveAllReportPages();
    },
    displayInsights(modalId, reportPageTypeName) {
      if (reportPageTypeName == "Table - Net Promoter Score") {
        this.$refs.insightsNPSTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.$parent.reportPagesList);
        this.$refs.insightsNPSTable.initializeInsights(this.$parent.$parent.clientChart);
        this.$modal.show(modalId);
      } else if (reportPageTypeName == "Chart - Net Promoter Score") {
        this.$refs.insightsNPSChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.$parent.reportPagesList);
        this.$refs.insightsNPSChart.initializeInsights(this.$parent.$parent.clientChart);
        this.$modal.show(modalId);
      } 
    },
    async drawNPSChart(){
      let chartOptions = ChartService.getChartOptions(this.containerId);
      let chartData = ChartService.buildNpsTrendsChartData(this.npsChartData,this.chartsLib);
      await ChartService.paintChart(this.npsChart, this.containerId, chartOptions, chartData, this);
    },
    async postPaintChart(primary_chart, containerId, options, dataTable) {
      let chartInterface = primary_chart.getChartLayoutInterface();
      let chartContainer = $("#" + containerId);
      let leftChart = chartInterface.getChartAreaBoundingBox().width / 2;
      let verticalLine = {
        top: chartInterface.getChartAreaBoundingBox().top,
        height: chartInterface.getChartAreaBoundingBox().height,
        left: chartInterface.getChartAreaBoundingBox().left + leftChart + 10
      };
      chartContainer.append(
        ChartService.paintVerticalLine(verticalLine.top, verticalLine.left, verticalLine.height, "black-vertical-line vertical-line")
      );      
      this.saveNpsReportPage();
    },
    async saveNpsReportPage() {
       if (this.$parent.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
/*        
        let tableContainerId = this.dataContainerId;
        let reportPageTableName = "Table - Net Promoter Score";
        let imageReportPageTableContent = await this.createTableImage(this, tableContainerId, false, 750, 10); 
        await ReportService.saveReportPage(imageReportPageTableContent, reportPageTableName, this.$parent.$parent.clientChart, this.$parent.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.tableImageUrl, "png", reportPageTableName, this.$parent.$parent.clientChart, this.$parent.saveReportPageCallback, this);
*/
        let reportPageChart = $("#by_word_cloud_nps_chart");
        let reportPageChartObject = reportPageChart[ 0 ];
        let imageReportPageChartContent = await this.createChartImage(reportPageChartObject, false, true); 
        await ReportService.saveReportPage(this.$parent.getReportTableContent(this.containerId), "Table - Net Promoter Score", this.$parent.$parent.clientChart, this.$parent.saveReportPageCallback, this);
        await ReportService.saveReportPage(imageReportPageChartContent, "Chart - Net Promoter Score", this.$parent.$parent.clientChart, this.$parent.saveReportPageCallback, this);
        await ReportService.saveReportPageFile(this.imageUrl, "png", "Chart - Net Promoter Score", this.$parent.$parent.clientChart, this.$parent.saveReportPageCallback, this);
        await ReportService.saveReportTableFile(
          this.$refs.npsDataTable.getTableData(),
          "Table - Net Promoter Score",
          this.$parent.$parent.clientChart,
          this.saveReportTableFileCallback,
          this
        );        
       }
    }
  },
  watch: {
    npsData: function(){
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.npsChart.getChart().clearChart();} catch(e){}

      if (this.drawChart == true){
        this.drawNPSChart();
      }
    }
  }
};
</script>
